export default __webpack_public_path__ + "dd3a5b4b3a302baa207ca6abd73c369a.png";